import { render, staticRenderFns } from "./shareModal.vue?vue&type=template&id=c356af52&scoped=true&"
import script from "./shareModal.vue?vue&type=script&lang=ts&"
export * from "./shareModal.vue?vue&type=script&lang=ts&"
import style0 from "./shareModal.vue?vue&type=style&index=0&id=c356af52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c356af52",
  null
  
)

export default component.exports